import React, { useState, useEffect } from "react";
import { Users, UserCheck, UserX } from "lucide-react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { getCounsellorList } from "../../api/Data/Counsellor";

export default function CounsellorCounter(props) {
  const dispatch = useDispatch();

  const [totalStudent, setTotal] = useState(0);
  const [activeStudent, setActive] = useState(0);
  const [inactive, setInactive] = useState(0);
  const getStudentLists = () => {
    let token = localStorage.getItem("token");
    dispatch(getCounsellorList("Bearer " + token)).then((res) => {
      console.log(res.payload.data.payload.data);
      if (Array.isArray(res.payload.data.payload.data)) {
        let arr = res.payload.data.payload.data;
        let totalLen = arr.length;
        let activeArr = arr.filter((item) => item.status === "ACTIVE");
        let inactiveArr = arr.filter((item) => item.status !== "ACTIVE");
        setTotal(totalLen);
        setActive(activeArr.length);
        setInactive(inactiveArr.length);
      }
    });
  };

  useEffect(() => {
    getStudentLists();
  }, []);
  return (
    <div className="w-full p-1">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5 items-stretch">
        <div className="flex flex-col w-full h-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-3 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-1.5">
            <div className="flex items-center justify-center w-[38px] h-[38px] rounded-xl bg-[#EFF6FF] text-[#2563EB]">
              <Users size={18} />
            </div>
          </div>
          <div className="text-[26px] leading-tight font-bold text-[#171717] font-poppins">
            {props.totalStudent}{" "}
            <span className="text-[13px] font-medium text-[#64748B]">Practitioners</span>
          </div>
          <p className="mt-0.5 mb-0 text-[13px] uppercase tracking-wide font-medium text-[#64748B] font-poppins">Total Practitioners</p>
        </div>
        <div className="flex flex-col w-full h-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-3 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-1.5">
            <div className="flex items-center justify-center w-[38px] h-[38px] rounded-xl bg-[#F0FDFA] text-[#0D9488]">
              <UserCheck size={18} />
            </div>
          </div>
          <div className="text-[26px] leading-tight font-bold text-[#171717] font-poppins">
            {props.activeStudent}{" "}
            <span className="text-[13px] font-medium text-[#64748B]">Practitioners</span>
          </div>
          <p className="mt-0.5 mb-0 text-[13px] uppercase tracking-wide font-medium text-[#64748B] font-poppins">Total Active</p>
        </div>
        <div className="flex flex-col w-full h-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-3 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-1.5">
            <div className="flex items-center justify-center w-[38px] h-[38px] rounded-xl bg-[#FFF7ED] text-[#EA580C]">
              <UserX size={18} />
            </div>
          </div>
          <div className="text-[26px] leading-tight font-bold text-[#171717] font-poppins">
            {props.inactive}{" "}
            <span className="text-[13px] font-medium text-[#64748B]">Practitioners</span>
          </div>
          <p className="mt-0.5 mb-0 text-[13px] uppercase tracking-wide font-medium text-[#64748B] font-poppins">Total Deactive</p>
        </div>
      </div>
    </div>
  );
}
